import { useGetMySummary } from "@/api/user/useGetMySummary";
import { Error } from "@/components/Error";
import { PersonalityTest } from "@/components/PersonalityTest/PersonalityTest";
import { Center, Loader, Stack, Text } from "@mantine/core";
import { useSearchParams } from "react-router-dom";
import { useGetPersonalityTestQuestions } from "./useGetPersonalityTestQuestions";
import { useSubmitPreviouslySubmittedAnswers } from "./useSubmitPreviouslySubmittedAnswers";

type Props = {};

export function PersonalityTestPage({}: Props) {
  const [searchParams] = useSearchParams();

  const isPersonalityTestOnly = searchParams.get("isPersonalityTestOnly") === "true";
  const {
    data: userSummary,
    isLoading: isUserSummaryLoading,
    isError: isUserSummaryError,
    isSuccess: isUserSummarySuccess,
    error: userSummaryError,
  } = useGetMySummary();

  const { isSubmittingPreviousAnswers } = useSubmitPreviouslySubmittedAnswers();
  const {
    questions,
    isLoading: isQuestionsLoading,
    isError,
    isSuccess,
    error: userQuestionsError,
  } = useGetPersonalityTestQuestions({
    isPersonalityTestOnly,
    enabled: !isSubmittingPreviousAnswers,
  });

  if (isQuestionsLoading || isUserSummaryLoading || isSubmittingPreviousAnswers) {
    if (isSubmittingPreviousAnswers) {
      return (
        <Center h="100%">
          <Stack align="center">
            <Loader />
            <Text>이전에 작성한 성격 테스트 답변을 제출하고 있습니다. 잠시만 기다려주세요.</Text>
          </Stack>
        </Center>
      );
    }
    return (
      <Center h="100%">
        <Loader />
      </Center>
    );
  }
  if (isError || isUserSummaryError || userQuestionsError || userSummaryError)
    return (
      <Error
        errorMessage={userQuestionsError?.message || userSummaryError?.message}
      />
    );

  if (isSuccess)
    return (
      <PersonalityTest
        questions={questions}
        isPersonalityTestOnly={isPersonalityTestOnly}
        userSummary={userSummary}
      />
    );

  return (
    <Center h="100%">
      <Loader />
    </Center>
  );
}
